<!-- 个人中心没有数据显示的页面 -->
<template>
  <div class="xf-profile-default">
    <div class="img-wrapper" v-if="type == 1">
      <div class="img-title">{{ title }}</div>
    </div>
    <div class="icon-wrapper" v-if="type == 2">
      <div class="icon-radius">
        <span class="iconfont icon-shuxie shuxie-reset"></span>
      </div>
      <p>{{ title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    title: {
      type: String,
      default: "暂无数据"
    },
    type: {
      default: 1
    }
  },
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
